import React, { Component } from 'react';

import { withRouter } from "react-router-dom";

import "../design/projecttasks.css";

class MilestoneList extends Component {

    constructor(props) {
        super(props);
        this.handleRedirectToMilestone = this.handleRedirectToMilestone.bind(this);
    }

    handleRedirectToMilestone(event, milestoneUuid) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.projectUUID + "/Milestone/" + milestoneUuid, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.projectUUID + "/Milestone/" + milestoneUuid);
        }
    }

    render() {
        console.log(this.props);
        const milestones = this.props.milestones;
        if (!milestones) return null;

        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>Milestone name</td>
                        </tr>
                    </thead>
                    <tbody>
                        {milestones.map((milestone) => (
                            <tr className="tr_hover"
                                key={milestone.milestoneUuid}
                                onClick={(event) => { this.handleRedirectToMilestone(event, milestone.milestoneUuid) }}
                            >
                                <td>{milestone.title}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(MilestoneList);


// WEBPACK FOOTER //
// ./src/components/milestoneList.js